<template>
    <v-dialog
        v-model="benchDialog"
        transition="dialog-transition"
        width="800"
        persistent
    >
        <v-card>
            <v-toolbar dark color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Bench Driver
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark icon @click="$emit('close')"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs>
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>
                                        Shift
                                    </th>
                                    <th>
                                        Shift Detail
                                    </th>
                                    <th>
                                        Driver
                                    </th>
                                    <th>
                                        Truck
                                    </th>
                                    <th>
                                        Trailer
                                    </th>
                                    <th>
                                        U. Repl.
                                    </th>
                                    <th>
                                        Yard
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{ itm.ShiftDate + ' ' + itm.Shift }}
                                    </td>
                                    <td>
                                        {{ itm.ShiftDetail }}
                                    </td>
                                    <td>
                                        {{ itm.Driver }}
                                    </td>
                                    <td>
                                        {{ itm.Truck }}
                                    </td>
                                    <td>
                                        {{ itm.Trailer }}
                                    </td>
                                    <td>
                                        {{ itm.ReplacementUnit }}
                                    </td>
                                    <td>
                                        {{ itm.Yard }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12">
                        <v-combobox
                            v-model="cause"
                            :items="causes"
                            :item-text="'BookedCauseDescription'"
                            :item-value="'BookedCauseID'"
                            label="Reason Type"
                            dense
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col cols="6" v-if="cause.ByTime == 1">
                        <v-text-field
                            label="Start Date"
                            hide-details
                            dense
                            v-model="StartDate"
                            v-mask="'####-##-##'"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" v-if="cause.ByTime == 1">
                        <v-text-field
                            label="End Date"
                            hide-details
                            dense
                            v-model="EndDate"
                            v-mask="'####-##-##'"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                        <v-textarea
                            outlined
                            placeholder="..."
                            auto-grow
                            label="Description"
                            v-model="description"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row justify="end">
                    <v-col cols="2" justify="end">
                        <v-btn color="primary" class="mx-2" @click="saveBook"
                            >Process</v-btn
                        >
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    props: ['benchDialog', 'itm'],
    directives: {
        mask
    },
    data: function() {
        return {
            causes: [],
            cause: '',
            description: '',
            StartDate: null,
            EndDate: null
        };
    },
    mounted() {
        this.loadCauses();
    },
    methods: {
        loadCauses: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('bookedoff-cause/active/bench')
                .then(response => {
                    this.causes = response.data;
                    console.log(this.causes);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        saveBook: function() {
            var str = this.$store;
            // this.$store.state.isLoading = true;
            var parms = {
                BookedCauseID: this.cause.BookedCauseID,
                BookedComments: this.description,
                ShiftHeaderNum: this.itm.ShiftHeaderNum,
                ShiftDetail: this.itm.ShiftDetail,
                Driver: this.itm.Driver,
                Truck: this.itm.Truck,
                RemplacementUnit: this.itm.ReplacementUnit,
                Trailer: this.itm.Trailer,
                TruckYard: this.itm.TruckYard,
                authRegDttm: ''
            };
            console.log(parms);
            axios
                .post('bookedoff', parms)
                .then(response => {
                    console.log(response.data);
                    this.editDriver();
                    this.deleteShift(this.itm.ShiftDetail);
                    // this.$store.state.book.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        deleteShift: function(index) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .delete('shift-detail/' + index)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'primary',
                        text: 'Shift removed successfully.'
                    });
                    this.$store.state.book.dialog = false;
                    this.$emit('closeRc');
                    this.$emit('close');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        editDriver: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            var parms = {
                BenchStart: this.StartDate,
                BenchEnd: this.EndDate
            };
            console.log(this.editedItem);
            axios
                .put('driver/' + this.itm.DriverID, parms)
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Driver information saved.'
                    });
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        }
    }
};
</script>
